<template>
    <div class="category-tag-page my-categoryTag-body"
         v-title :data-title="categoryTagTitle">
        <div class="my-categoryTag-container">
            <!-- 自定义 Tab 栏，避免 el-tabs 显示不全 -->
            <div class="category-tab-bar">
                <span :class="['tab-item', { active: activeName === 'category' }]" @click="switchTab('category')">文章分类</span>
                <span :class="['tab-item', { active: activeName === 'tag' }]" @click="switchTab('tag')">标签</span>
            </div>
            <div class="category-tab-content">
                <ul v-show="activeName === 'category'" class="my-categoryTag-items">
                    <li v-for="c in categories" @click="view(c.id)" :key="c.id" class="my-categoryTag-item">
                        <div class="my-categoryTag-content">
                            <a class="my-categoryTag-info">
                                <span class="my-categoryTag-icon-wrap">
                                    <img class="my-categoryTag-img" :src="c.avatar?c.avatar:defaultAvatar" alt=""/>
                                </span>
                                <h4 class="my-categoryTag-name">{{displayCategoryName(c.categoryName)}}</h4>
                                <p class="my-categoryTag-description">{{c.description}}</p>
                            </a>
                            <div class="my-categoryTag-meta">
                                <span>{{c.articlesNumber}} 篇文章</span>
                            </div>
                        </div>
                    </li>
                </ul>
                <ul v-show="activeName === 'tag'" class="my-categoryTag-items">
                    <li v-for="t in tags" @click="view(t.id)" :key="t.id" class="my-categoryTag-item">
                        <div class="my-categoryTag-content">
                            <a class="my-categoryTag-info">
                                <span class="my-categoryTag-icon-wrap">
                                    <img class="my-categoryTag-img" :src="t.avatar?t.avatar:defaultAvatar" alt=""/>
                                </span>
                                <h4 class="my-categoryTag-name">{{displayTagName(t.tagName)}}</h4>
                            </a>
                            <div class="my-categoryTag-meta">
                                <span>{{t.articlesNumber}} 篇文章</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import defaultAvatar from '@/assets/img/logo.png'
    import {listTagsDetail} from "@/api/tag"
    import {listCategoriesDetail} from "@/api/category"

    export default {
        name: "BlogAllCategoryTag",
        data() {
            return {
                categories: [],
                tags: [],
                defaultAvatar: defaultAvatar
            }
        },
        computed: {
            activeName() {
                return this.$route.params.type || 'category';
            },
            categoryTagTitle() {
                return this.activeName === "category" ? "文章分类" : "标签";
            }
        },
        created() {
            this.listCategories();
            this.listTags();
        },
        methods: {
            //获取全部的分类列表
            listCategories() {
                //发起http请求 请求后端的数据
                listCategoriesDetail().then((res) => {
                    ////res.data = Result (success,msg,data)
                    if (res.data.success) {
                        this.categories = res.data.data;
                        console.log(this.categories)
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$message.error("系统错误");
                }).finally(() => {
                })
            },
            //获取全部的标签列表
            listTags() {
                //发起http请求 请求后端的数据
                listTagsDetail().then((res) => {
                    ////res.data = Result (success,msg,data)
                    if (res.data.success) {
                        this.tags = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$message.error("系统错误");
                }).finally(() => {
                })
            },
            //获取分类、标签详情
            view(id) {
                this.$router.push({path: `/${this.activeName}/${id}`});
            },
            switchTab(name) {
                this.$router.push({ path: `/${name}/all` });
            },
            /* 展示时修正「前端端」多字为「前端」 */
            displayCategoryName(name) {
                if (!name) return '';
                return name.replace(/^前端端$/, '前端');
            },
            displayTagName(name) {
                if (!name) return '';
                return name.replace(/^前端端$/, '前端');
            }
        }
    }
</script>

<style scoped>
    .my-categoryTag-body {
        margin: 40px auto 16px;
        padding-bottom: 16px;
        overflow: visible;
    }

    .my-categoryTag-container {
        width: 100%;
        max-width: 1200px;
        padding: 0 20px;
        margin: 0 auto;
        box-sizing: border-box;
        overflow: visible;
    }

    .my-categoryTag-container .el-main {
        padding: 0;
        overflow: visible;
    }

    /* 自定义 Tab 栏：赛博朋克风格，确保文字完整显示 */
    .category-tab-bar {
        display: flex;
        justify-content: center;
        align-items: stretch;
        flex-wrap: nowrap;
        flex-shrink: 0;
        gap: 0;
        margin-bottom: 24px;
        padding: 8px 8px 0;
        border-bottom: 1px solid rgba(0, 255, 245, 0.15);
        overflow: visible;
        min-height: 50px;
        width: 100%;
    }

    .category-tab-bar .tab-item {
        flex-shrink: 0;
        min-width: 100px;
        padding: 16px 36px 12px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        cursor: pointer;
        transition: color 0.2s ease, border-color 0.2s ease;
        white-space: nowrap;
        overflow: visible;
        border-bottom: 3px solid transparent;
        margin-bottom: -1px;
        box-sizing: border-box;
    }

    .category-tab-bar .tab-item:hover {
        color: rgba(0, 255, 245, 0.85);
    }

    .category-tab-bar .tab-item.active {
        color: #00fff5;
        border-bottom-color: #00fff5;
        text-shadow: 0 0 8px rgba(0, 255, 245, 0.4);
    }

    .my-categoryTag-items {
        padding-top: 1rem;
        list-style: none;
        margin: 0 auto;
        padding-left: 0;
        padding-bottom: 0;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0;
    }

    .my-categoryTag-item {
        flex: 0 1 260px;
        min-width: 200px;
        margin-bottom: 1.5rem;
        padding: 0 10px;
        box-sizing: border-box;
    }

    /* 赛博朋克玻璃风卡片 */
    .my-categoryTag-content {
        display: inline-block;
        width: 100%;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.25);
        border-radius: 12px;
        transition: all 0.3s ease;
        text-align: center;
        padding: 1.5rem 0;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    }

    .my-categoryTag-content:hover {
        border-color: rgba(0, 255, 245, 0.5);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 25px rgba(0, 255, 245, 0.15);
    }

    .my-categoryTag-info {
        cursor: pointer;
        text-decoration: none;
    }

    /* 科技风图标容器：霓虹边框 + 发光 */
    .my-categoryTag-icon-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: -40px 0 10px;
        width: 64px;
        height: 64px;
        border-radius: 14px;
        border: 1px solid rgba(0, 255, 245, 0.4);
        background: rgba(0, 255, 245, 0.06);
        box-shadow:
            inset 0 0 20px rgba(0, 255, 245, 0.08),
            0 0 18px rgba(0, 255, 245, 0.25),
            0 0 36px rgba(0, 255, 245, 0.12);
    }

    .my-categoryTag-content:hover .my-categoryTag-icon-wrap {
        border-color: rgba(0, 255, 245, 0.6);
        box-shadow:
            inset 0 0 24px rgba(0, 255, 245, 0.12),
            0 0 24px rgba(0, 255, 245, 0.45),
            0 0 48px rgba(0, 255, 245, 0.2);
    }

    .my-categoryTag-img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        vertical-align: middle;
        /* 统一成科技风：降饱和、偏青色调、霓虹发光 */
        filter:
            saturate(0.5) hue-rotate(165deg) brightness(1.08) contrast(1.08)
            drop-shadow(0 0 8px rgba(0, 255, 245, 0.5))
            drop-shadow(0 0 16px rgba(0, 255, 245, 0.25));
    }

    .my-categoryTag-name {
        font-size: 21px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-top: 4px;
        color: rgba(224, 242, 254, 0.98);
    }

    .my-categoryTag-description {
        min-height: 50px;
        font-size: 13px;
        line-height: 25px;
        color: rgba(203, 213, 225, 0.85);
    }

    .my-categoryTag-meta {
        font-size: 12px;
        color: rgba(148, 163, 184, 0.9);
    }

    @media (max-width: 768px) {
        .my-categoryTag-item {
            flex: 0 1 50%;
            min-width: 140px;
        }

        .category-tab-bar {
            padding: 0 4px;
        }

        .category-tab-bar .tab-item {
            min-width: 80px;
            padding: 12px 24px;
            font-size: 15px;
        }
    }
</style>

<style>
    /* 文章分类/标签页 Tabs 赛博朋克风格（非 scoped，影响 el-tabs） */
    .category-tag-page .el-tabs__header {
        margin-bottom: 16px;
        border-bottom: 1px solid rgba(0, 255, 245, 0.2);
    }

    .category-tag-page .el-tabs__nav-wrap {
        display: flex;
        justify-content: center;
        overflow: visible;
    }

    .category-tag-page .el-tabs__nav {
        overflow: visible;
    }

    .category-tag-page .el-tabs__nav-wrap::after {
        background: transparent;
    }

    .category-tag-page .el-tabs__item {
        color: rgba(255, 255, 255, 0.7) !important;
        padding: 0 24px !important;
        min-width: 80px;
        text-align: center;
        white-space: nowrap;
    }

    .category-tag-page .el-tabs__item:hover {
        color: rgba(0, 255, 245, 0.9) !important;
    }

    .category-tag-page .el-tabs__item.is-active {
        color: #00fff5 !important;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.6), 0 0 20px rgba(0, 255, 245, 0.25);
    }

    .category-tag-page .el-tabs__item:focus,
    .category-tag-page .el-tabs__item:active,
    .category-tag-page .el-tabs__item.is-active:focus,
    .category-tag-page .el-tabs__item.is-active:active {
        color: #00fff5 !important;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.6), 0 0 20px rgba(0, 255, 245, 0.25);
        outline: none !important;
    }
    .category-tag-page .el-tabs__item:focus *,
    .category-tag-page .el-tabs__item:active *,
    .category-tag-page .el-tabs__item.is-active:focus *,
    .category-tag-page .el-tabs__item.is-active:active * {
        color: inherit !important;
    }

    .category-tag-page .el-tabs__active-bar {
        background-color: #00fff5 !important;
        height: 3px !important;
        box-shadow: 0 0 12px rgba(0, 255, 245, 0.8), 0 0 24px rgba(0, 255, 245, 0.3);
    }

    .category-tag-page .el-tabs__ink-bar {
        background-color: #00fff5 !important;
        height: 3px !important;
        box-shadow: 0 0 12px rgba(0, 255, 245, 0.8);
    }

    .category-tag-page .el-tabs__nav {
        border: none;
        overflow: visible;
    }

    .category-tag-page .el-tabs__content {
        overflow: visible !important;
    }

    .category-tag-page .el-tabs__indicator {
        background-color: #00fff5 !important;
        box-shadow: 0 0 12px rgba(0, 255, 245, 0.6);
    }

    .category-tag-page .el-tabs__item .el-icon-arrow-left,
    .category-tag-page .el-tabs__item .el-icon-arrow-right {
        color: rgba(0, 255, 245, 0.8);
    }
</style>
